import moment from "moment";
import { Link } from "react-router-dom";
import { Badge, Table } from "reactstrap";
import TableHeader from "./TableHeader";
import {
  getShippingIdentifierShort,
  isComingToTechMicro,
} from "../../utils/shippingIdentifier";

const PurchaseOrderRow = ({ row, index }) => {
  const isComingToTM = isComingToTechMicro(row);
  const shippingLabel = getShippingIdentifierShort(row);

  return (
    <tr
      style={{
        backgroundColor: index % 2 === 0 ? "#3BE7FF12" : "#F7F7F780",
      }}
    >
      <td style={{ verticalAlign: "middle" }}>
        <div className="d-flex flex-column align-items-start gap-1">
          <span>{moment(row?.created_at).format("L")}</span>
          <span
            style={{
              display: "inline-block",
              fontSize: "10.5px",
              fontWeight: 600,
              padding: "2px 7px",
              borderRadius: "4px",
              whiteSpace: "nowrap",
              lineHeight: "1.25",
              backgroundColor: isComingToTM ? "#dbeafe" : "#dcfce7",
              color: isComingToTM ? "#1d4ed8" : "#166534",
              border: `1px solid ${isComingToTM ? "#bfdbfe" : "#86efac"}`,
            }}
          >
            {shippingLabel}
          </span>
        </div>
      </td>
    <td>{row?.po_no}</td>
    <td>{row?.vendor?.company}</td>
    <td>{row?.vendorPoNumber ?? "Not Given"}</td>
    <td>
      <select>
        {row?.line_items?.length > 0 ? (
          row.line_items.map((i, index) => (
            <option key={index} value={i.sku}>
              {`${i.sku} - ${i.quantity}`}
            </option>
          ))
        ) : (
          <option disabled>Not Given</option>
        )}
      </select>
    </td>
    <td>${(parseFloat(row?.total) || 0).toFixed(2)}</td>

    <td>
      {row?.purchaseOrderStatus === "cancel" ? (
        <Badge color="danger">Cancelled</Badge>
      ) : row?.purchaseOrderStatus === "active" ? (
        "Active"
      ) : (
        "Inactive"
      )}
    </td>
    <td className="salesTd">
      <Link
        to={{
          pathname: `/admin/update-purchase-orders-details/${row?._id}`,
          state: {
            obj: row,
            vendor: {
              billing: [row?.vendor],
              id: row?.vendorOrderId,
              _id: row?.vendorId,
            },
          },
        }}
        className="text-decoration-none primary-color"
      >
        View
      </Link>
      <Link
        to={{
          pathname: `/admin/generate-purchase-orders-details/${row?._id}`,
          state: {
            obj: row,
            id: row?.id,
            vendor: {
              billing: [row?.vendor],
              id: row?.vendorOrderId,
              _id: row?.vendorId,
            },
          },
        }}
        className="text-decoration-none primary-color mx-3"
      >
        Generate PDF
      </Link>
    </td>
  </tr>
  );
};

const PosInsideSo = ({ all_purchase_orders }) => {
  return (
    <div>
      {all_purchase_orders?.length > 0 && (
        <>
          <h5>Purchase Orders</h5>
          <div className="my-2  ">
            <Table
              responsive
              hover
              bordered
              style={{
                fontSize: "13px",
                overflow: "hidden",
              }}
              className="mb-0"
            >
              <TableHeader
                items={[
                  "Created At",
                  "PO",
                  "Vendor",
                  "Vendor Po Number",
                  "SKU",
                  "Total",
                  "Status",
                  "Action",
                ]}
                headerClass={" text-center"}
                backgroundColor={"#00509d2E"}
              />

              <tbody>
                {all_purchase_orders?.map((row, idx) => (
                  <PurchaseOrderRow key={idx} index={idx} row={row} />
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
};
export default PosInsideSo;
